import { secureApi } from 'services/api';
import {
  categoriesAdapter,
  initialResourcesState,
  modelsAdapter,
} from 'services/api/resources/adapters';
import {
  NormalizedResourcesState,
  ResourcesDto,
} from 'services/api/resources/types';
import slugify from 'utils/text/slugify';

export const resourcesApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    // locale is a part of a query cache key
    getResources: builder.query<NormalizedResourcesState, { locale: string }>({
      query: _ => ({
        url: `/api/models`,
        method: 'GET',
        useAnonymous: true,
      }),
      /**
       * Singleton Cache Strategy:
       * 1. serializeQueryArgs: Ignores arguments to maintain a single cache entry.
       * This allows selectors to access data without knowing the current locale.
       * 2. forceRefetch: Manually triggers a re-request when the locale changes,
       * overwriting the single cache entry with new data.
       */
      serializeQueryArgs: ({ endpointName }) => endpointName,
      forceRefetch: ({ currentArg, previousArg }) =>
        currentArg?.locale !== previousArg?.locale,
      transformResponse: (response: ResourcesDto) => {
        const categoriesWithSlugs = response.categories.map(cat => ({
          ...cat,
          slug: slugify(cat.name),
        }));

        return {
          categories: categoriesAdapter.setAll(
            initialResourcesState.categories,
            categoriesWithSlugs,
          ),
          models: modelsAdapter.setAll(
            initialResourcesState.models,
            response.models,
          ),
        };
      },
    }),
  }),
  overrideExisting: true,
});
